import { useState, useEffect, useRef } from 'react';
import { Modal } from '../theme/Component/Modal';
import { Singleton } from '../../core/services/Singleton';
import { AdminService } from '../../core/services/AdminService';
import { BasicTable } from '../theme/Component/BasicTable';
import { useDashboardStore } from '../pages/hooks/useDashboardStore';
import { toast } from 'react-toastify';
import { BpmService } from '../../core/services/BpmService';
import { DataBeanProperties } from '../../core/services/model/server-response.interface';
import { PrintJson } from '../theme/Component/PrintJson';
import usePaginator from '../theme/Component/usePaginator';
import { _single } from '../../core/services/dataBean/EntityCatalog';

interface Editor {
    idAccount: number | null;
    label: string | undefined;
    disabled?: boolean
    onChange: any;
    canCreate?: boolean
    render?: string;
}

const head = [
    { title: 'ID', property: 'IDAccount', visible: false },
    { title: 'Identificacion', property: 'Nit' },
    { title: 'Nombre', property: 'EntityName' },

]

export const AccountEditorWhitRender = ({ idAccount, label, onChange, disabled, canCreate, render }: Editor) => {

    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service: AdminService = new AdminService();
    const serviceBPM = new BpmService();
    const [valor, setValor] = useState(idAccount);
    const [nit, setNit] = useState('');
    const [entityName, setEntityName] = useState('');
    const [bean, setBean] = useState<any>({});
    const [beanAcc, setBeanAcc] = useState<any>({});
    const [filter, setFilter] = useState<any>({});


    const [lista, setLista] = useState([]);
    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalAdd, setModalAdd] = useState<any>({ name: 'Crear Usuario', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const paginador = usePaginator();


    useEffect(() => {

        return () => {
            setFilter({});
            setLista([]);
            setNit('');
            // idAccount=0;
        }
    }, [])
    useEffect(() => {
        setEntityName('');
        getAccountByID(idAccount);
        return () => {
            setLista([]);
            setNit('');
            // idAccount=0;
        }
    }, [idAccount])
    useEffect(() => {
        getAccountPaginador();
    }, [paginador.page])


    useEffect(() => {

        setEntityName(bean.EntityName);
        setNit(bean.EntityName);
        setValor(bean.IDAccount);

    }, [bean])


    const getAccountByID = (id: number | null) => {
        if (id !== null && id !== undefined && !isNaN(id)) {
            setLoading(true);
            service.getAccountByID(id).subscribe(
                (resp: any) => {
                    if (resp.DataBeanProperties.ObjectValue) {
                        let obj: any = resp.DataBeanProperties.ObjectValue;
                        setBean(resp.DataBeanProperties.ObjectValue.DataBeanProperties);
                    }
                    setLoading(false);
                }
            );
        } else {
            setBean({});
            setLoading(false);
        }
    };

    const getAccount = () => {
        if (nit)
            if (nit.length > 3) {
                setLoading(true);
                if (!isNaN(parseInt(nit))) {
                    service.getAccountByNit(parseInt(nit)).subscribe(
                        (resp: any) => {
                            let list = [];
                            if (resp.DataBeanProperties.ObjectValue) {
                                list = resp.DataBeanProperties.ObjectValue;
                            }
                            if (list.length == 0)
                                toast.success("No se encontraron resultados");
                            setLista(list);
                            setLoading(false);
                        }
                    );
                } else {
                    let listaTemp: any = [];
                    setLoading(true);
                    service.getAccountByName(nit, null).subscribe(
                        (resp: any) => {

                            if (resp.DataBeanProperties.ObjectValue) {

                                listaTemp = resp.DataBeanProperties.ObjectValue;

                                service.getAccountByName(null, nit).subscribe(
                                    (resp: any) => {
                                        if (resp.DataBeanProperties.ObjectValue) {
                                            Array.prototype.push.apply(listaTemp, resp.DataBeanProperties.ObjectValue);

                                        }
                                        if (listaTemp.length == 0)
                                            toast.success("No se encontraron resultados");
                                        setLista(listaTemp);
                                    }
                                );
                            }
                            setLoading(false);
                        }
                    );
                }
            } else {
                toast.error("De especificar un documento de identidad.");
            }
    }

    const getAccountPaginador = () => {
        _single.spinner(true);
        service.searchAbtractAccount(paginador.page, 15, filter.Nit == '' ? null : filter.Nit,
            filter.Name == '' ? null : filter.Name, filter.Surname == '' ? null : filter.Surname, 0).subscribe(
                (resp: any) => {
                    console.log(resp);
                    if (resp.DataBeanProperties.ObjectValue) {
                        let data = resp.DataBeanProperties.ObjectValue;

                        if (data.DataBeanProperties.List) {
                            let lista = data.DataBeanProperties.List;
                            lista.forEach(element => {
                                element.DataBeanProperties.EntityName =
                                    (element.DataBeanProperties.Name1 ?? '') + " " +
                                    (element.DataBeanProperties.Name2 ?? '') + " " +
                                    (element.DataBeanProperties.Surname1 ?? '') + " " +
                                    (element.DataBeanProperties.Surname2 ?? '');

                                element.DataBeanProperties.Nit = element.DataBeanProperties.Nit ?? element.DataBeanProperties.nit;


                            });
                            setLista(lista);
                            paginador.setPages(data.DataBeanProperties.NumberOfPages);
                        }
                    } else {
                        toast.warning("No se encontraron resultados");
                    }
                    _single.spinner(false);
                }
            );
    }

    const agregarItem = () => {

        let b = {
            Nit: nit,
            Name1: '',
            Name2: '',
            Surname1: '',
            Surname2: '',
            Tel: undefined,
            eMail: '',
        }
        setBeanAcc(b);
        setModalAdd({ ...modalAdd, 'view': true });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: canCreate, icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const updateItem = () => {
        //console.log(beanAcc)

        if (beanAcc.Nit > 0) {
            setLoading(true);
            serviceBPM.createAccount(beanAcc).subscribe(
                (resp: any) => {

                    if (resp.DataBeanProperties.ObjectValue) {

                        setNit(beanAcc.Nit);
                        toast.success("Se ha creado el usuario")
                        setModalAdd({ ...modalAdd, "view": false });
                        getAccount();
                    }
                    setLoading(false);
                });
        }
        else {
            toast.error("No ha especificado un valor valido para documento de identidad.");
        }

    }
    const limpiar = () => {
        setFilter({ Nit: null, Name: null, Surname: null });
    }

    return (
        <>
            {label != '' && <label>{label}</label>}
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                disabled={disabled}
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={render ?? ''}
                onClick={() => { setModal({ ...modal, view: true }); }}
                onChange={() => { }}
            />

            <Modal modal={modal} updateModal={setModal} >
                <div className="row">
                    <div className="col-md">
                        <div className="input-group">
                            <input placeholder='Identificación' type="text" name="identificacion" id="Identificacion"
                                className='form-control text-uppercase' value={filter.Nit ?? undefined} onChange={(e) => { setFilter({ ...filter, "Nit": e.target.value }) }} />
                            <input placeholder='Nombre' type="text" name="nombre" id="nombre"
                                className='form-control text-uppercase' value={filter.Name ?? undefined} onChange={(e) => { setFilter({ ...filter, "Name": e.target.value }) }} />
                            <input placeholder='Apellido' type="text" name="apellido" id="apellido"
                                className='form-control text-uppercase' value={filter.Surname ?? undefined} onChange={(e) => { setFilter({ ...filter, "Surname": e.target.value }) }} />

                            <button className="btn btn-success" type="button" onClick={() => {
                                getAccountPaginador();
                                paginador.setPage(1);
                            }}>Buscar</button>
                            <button className="btn btn-danger" type="button" onClick={limpiar}>Limpiar</button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-4">
                        <BasicTable iconButtons={iconButtonsItem} head={head} body={lista} rowSet={(bean: any) => {
                            onChange(bean);
                            setBean(bean);
                            setModal({ ...modal, 'view': false });
                        }}
                            pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                        ></BasicTable>
                    </div>

                    <div className="col-md-12">
                        <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={updateItem} >
                            <div className="row">
                                <div className="col-md-12">
                                    <label className="form-label">No. Identificación *</label>
                                    <input type="number" className="form-control" value={beanAcc.Nit} onBlur={(e) => {
                                    }} onChange={(e) => {
                                        setBeanAcc({ ...beanAcc, 'Nit': parseInt(e.target.value) })
                                    }} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Primer Nombre *</label>
                                    <input type="text" className="form-control" value={beanAcc.Name1} onChange={(e) => { setBeanAcc({ ...beanAcc, 'Name1': e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Segundo Nombre </label>
                                    <input type="text" className="form-control" value={beanAcc.Name2} onChange={(e) => { setBeanAcc({ ...beanAcc, 'Name2': e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Primer Apellido *</label>
                                    <input type="text" className="form-control" value={beanAcc.Surname1} onChange={(e) => { setBeanAcc({ ...beanAcc, 'Surname1': e.target.value }) }} />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Segundo Apellido *</label>
                                    <input type="text" className="form-control" value={beanAcc.Surname2} onChange={(e) => { setBeanAcc({ ...beanAcc, 'Surname2': e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Celular *</label>
                                    <input type="number" className="form-control" value={beanAcc.Tel} onChange={(e) => { setBeanAcc({ ...beanAcc, 'Tel': e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Correo Electronico *</label>
                                    <input type="text" className="form-control" value={beanAcc.eMail} onChange={(e) => { setBeanAcc({ ...beanAcc, 'eMail': e.target.value }) }} />
                                </div>


                            </div>
                        </Modal>
                    </div>
                </div>
            </Modal>
        </>
    )
}